const { CONSTANTS } = require('../../config')
const { getAgeFromSsn } = require('../../utils')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string} country
 * @param {*} value
 * @param {boolean} validationValue
 * @returns {boolean}
 */
function age ({ country, value, validationValue }) {
  if (!validationValue) return true
  if (!country || !value) return false

  const age = getAgeFromSsn({ country, value })
  if (!age) return false

  return (
    age >= CONSTANTS[country?.toUpperCase()]?.AGE?.MIN &&
    age <= CONSTANTS[country?.toUpperCase()]?.AGE?.MAX
  )
}

module.exports = { age }
